module.exports = __webpack_public_path__ + "static/media/upa.5532f9e0.jpeg";